import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  StyledServiceCard,
  StyledServiceCardImg,
  StyledServiceCardContent,
  StyledServiceCardTitle,
  StyledServiceCardText,
  StyledServiceCardBtn,
  StyledInsertServicesText
} from '../KindergartenServicesStyle';
import './../KindergartenServicesTranslate';
import Button from '@material-ui/core/Button';
import { history } from '../../../_helpers/history';
import { withStyles } from '@material-ui/styles';
import { Box } from '@material-ui/core';

const ColorButton = withStyles(theme => ({
  root: {
    padding: '12px 40px',
    fontWeight: '700',
    fontSize: '14px',
    textTransform: 'uppercase',
    letterSpacing: '0.01em',
    fontFamily: 'Montserrat',
    '@media (max-width:1000px)': {
      padding: '15px 30px'
    }
  }
}))(Button);

const ContainerRow = withStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'flex-end',
    gap: theme.spacing(2)
  }
}))(Box);

const ColumnBox = withStyles(theme => ({
  root: {
    minHeight: 80
  }
}))(Box);

function OurServiceCard({ metadata }) {
  const { t, i18n } = useTranslation();
  return (
    <StyledServiceCard>
      <StyledServiceCardContent>
        <StyledServiceCardImg>
          <img src={metadata[`img`]} alt={metadata[`${i18n.language}_name`]} />
        </StyledServiceCardImg>
        <StyledServiceCardTitle children={metadata[`${i18n.language}_name`]} />
        <StyledServiceCardText children={metadata[`${i18n.language}_text`]} />
      </StyledServiceCardContent>
      <StyledServiceCardBtn>
        {metadata.isTwoButton ? (
          <ContainerRow>
            <ColumnBox>
              <StyledInsertServicesText>
                {t('kindergarten_region')}
              </StyledInsertServicesText>
              <ColorButton
                variant="contained"
                color="secondary"
                onClick={() => {
                  if (!metadata.url) {
                    history.push(`/services/create/${metadata.code}`);
                  } else {
                    history.push(metadata.url);
                  }
                }}
                children={t('kindergarten_go')}
              />
            </ColumnBox>
            <ColumnBox>
              <StyledInsertServicesText>
                {t('kindergarten_city')}
              </StyledInsertServicesText>
              <ColorButton
                variant="contained"
                color="secondary"
                onClick={() => {
                  if (!metadata.url) {
                    history.push(`/services/create/${metadata.codeVoucher}`);
                  } else {
                    history.push(metadata.url);
                  }
                }}
                children={t('kindergarten_go')}
              />
            </ColumnBox>
          </ContainerRow>
        ) : (
          <ColorButton
            variant="contained"
            color="secondary"
            onClick={() => {
              if (!metadata.url) {
                history.push(`/services/create/${metadata.code}`);
              } else {
                history.push(metadata.url);
              }
            }}
            children={t('kindergarten_go')}
          />
        )}
      </StyledServiceCardBtn>
    </StyledServiceCard>
  );
}

export default OurServiceCard;
